import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { OrderParkingVM, EditOrderParking } from '../models/orderModel';

@Injectable({
  providedIn: 'root'
})
export class OrderParkingService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  orderParkingPath = 'Shuttlebuss/Shuttlebuss.Service/orderparking';

  constructor(private http: HttpClient) {}

  public getOrderParking(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}${this.orderParkingPath}/orderparking/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderparking => {
        return orderparking;
      }),
      catchError(this.handleError)
    );
  }

  public editOrderParking(editOrderParking: EditOrderParking): Observable<any> {
    // alert('orderparking.service');
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/orderparking/editorderparking';
    return this.http
      .post<EditOrderParking>(url, editOrderParking, { headers })
      .pipe(map(orderParkingVM => {
          return orderParkingVM;
        }),
        catchError(this.handleError)
      );
  }

  public getOrderParkingsPaidBetweenParkingFromDate(parkingDateFrom: string, parkingDateTo: string): Observable<any> {
    const URL = `${this.hostPath}${this.orderParkingPath}/orderparkings/${parkingDateFrom}/${parkingDateTo}`;
    return this.http.get<any>(URL).pipe(
      map(orderParkings => {
        return orderParkings;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderParkingCarId(carId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}${this.orderParkingPath}/orderparkingcarid/${carId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderparking => {
        return orderparking;
      }),
      catchError(this.handleError)
    );
  }

  public setCarId(orderParkingId: string, carId: string): Observable<any> {
    const URL = `${this.hostPath}${this.orderParkingPath}/setcarid/${orderParkingId}/${carId}`;
    return this.http.get<any>(URL).pipe(
      map(orderParkings => {
        return orderParkings;
      }),
      catchError(this.handleError)
    );
  }

  public setComment(orderParkingId: string, comment: string): Observable<any> {
    const URL = `${this.hostPath}${this.orderParkingPath}/setcomment/${orderParkingId}/${comment}`;
    return this.http.get<any>(URL).pipe(
      map(orderParkings => {
        return orderParkings;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`orderParkingService.handleError ${errMsg}`);
    return throwError(error);
  }
}
